<h2 mat-dialog-title>
  Betalingsbilag
  <mat-divider></mat-divider>
</h2>
<mat-dialog-content>
  <form [formGroup]="form">
    <div class="mb-2">
      <mat-checkbox ngDefaultControl formControlName="receipts_amount_check">Summen af bilagsbeløb skal mindst svare til det anmodede beløb.</mat-checkbox>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button mat-dialog-close>Luk</button>
  <button mat-flat-button (click)="doSave()">Gem</button>
</mat-dialog-actions>
